module.exports = __webpack_public_path__ + "img/demo-takeout.3dae896f.jpg";